import React, {Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {Button, Form, Grid, Header, Icon, Message, Segment} from "semantic-ui-react";

import {signIn, updateEmail, updatePassword} from "../../actions/signIn";

class SignIn extends Component {

    componentDidMount() {
        if (this.props.authenticated) {
            this.props.history.push("/")
        }
    }

    componentDidUpdate() {
        if (this.props.authenticated) {
            this.props.history.push("/")
        }
    }

    onChangeEmail(e) {
        this.props.dispatch(updateEmail(e.target.value));
    }

    onChangePassword(e) {
        this.props.dispatch(updatePassword(e.target.value));
    }

    onClickSignIn() {
        this.props.dispatch(signIn(this.props.email, this.props.password));
    }

    render() {
        return (
            <Grid style={{height: "100%"}} textAlign="center" verticalAlign="middle">
                <Grid.Column style={{maxWidth: 450}}>
                    <Segment.Group>
                        <Segment>
                            <Header as="h3">
                                <Icon name="sign in"/>
                                <Header.Content>Logowanie</Header.Content>
                            </Header>
                        </Segment>
                        <Segment>
                            {this.props.sessionExpired && <Message
                                negative
                                icon>
                                <Icon name='time'/>
                                <Message.Content style={{textAlign: "left"}}>
                                    Nastąpiło automatyczne wylogowanie po 15 min bezczynności.
                                </Message.Content>
                            </Message>}
                            <Form loading={this.props.signing}>
                                <Form.Input
                                    icon="mail"
                                    iconPosition="left"
                                    placeholder="E-mail"
                                    value={this.props.email}
                                    disabled={this.props.signing}
                                    onChange={(e) => {
                                        this.onChangeEmail(e)
                                    }}/>
                                <Form.Input
                                    type="password"
                                    icon="key"
                                    iconPosition="left"
                                    placeholder="Hasło"
                                    value={this.props.password}
                                    disabled={this.props.signing}
                                    onChange={(e) => {
                                        this.onChangePassword(e)
                                    }}/>
                                {this.props.error && <Message negative>{this.props.error}</Message>}
                                <Button positive onClick={(e) => {
                                    this.onClickSignIn(e)
                                }}>Zaloguj się</Button>
                            </Form>
                        </Segment>
                        <Segment>
                            <p>Jeśli nie posiadasz konta? <Link to="/rejestracja">Zarejestruj się!</Link></p>
                            <p>Nie pamiętasz hasła? <Link to="/resetowanie-hasla">Zresetuj hasło!</Link></p>
                        </Segment>
                    </Segment.Group>
                </Grid.Column>
            </Grid>
        );
    }
};

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        email: state.signIn.email,
        password: state.signIn.password,
        signing: state.signIn.signing,
        error: state.signIn.error,
        sessionExpired: state.signIn.sessionExpired
    }
}

export default withRouter(connect(mapStateToProps)(SignIn))



// WEBPACK FOOTER //
// ./src/components/routes/SignIn.js